import {TFunction} from 'react-i18next';
import {formatDateTime} from 'i18n/localeDateFormat';
import i18n from 'i18n/i18n';
import Excel from 'exceljs';
import {renderHeaderXL, createZIPXL} from './ExcelExportCommon';
import {PogisDocumentModified} from 'features/Archive/PogisDocumentPage';

interface IPOGISPage {
	(entityListItems: any[], columnNames: string[], t: TFunction): Promise<void>;
}

export const handleClickPOGISPage: IPOGISPage = async (
	entityListItems,
	columnNames,
	t,
) => {
	const arrPOGISFilt = entityListItems as PogisDocumentModified[];

	const strTrNS = 'features/pogisdocuments';
	const strTrPrefix = 'PogisDocumentsList';
	const strPageName = 'POGIS';
	const columns = columnNames.map(x => {
		return {name: x, filterButton: true};
	});
	const arrColWidth = [10, 40, 40, 40, 80, 40, ...new Array(11).fill(25)];
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet('TRACE_' + strPageName);
	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};
	sheet.addTable({
		name: 'tablePOGIS',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns,
		rows: [],
	});
	intRowCount++;
	const regex = /POGIS\sSummary\s\d+\.pdf/g;
	const table = sheet.getTable('tablePOGIS');
	for (let ii = 0; ii < arrPOGISFilt.length; ii++) {
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		table.addRow([
			arrPOGISFilt[ii].pogisId,

			arrPOGISFilt[ii].keywords.join(';\n'),

			arrPOGISFilt[ii].markets.join(';\n'),

			(arrPOGISFilt[ii].standards ?? []).join(';\n'),

			arrPOGISFilt[ii].shortInfo,

			'',

			arrPOGISFilt[ii].effectiveDate
				? formatDateTime(new Date(arrPOGISFilt[ii].effectiveDate), i18n)
				: '',

			arrPOGISFilt[ii].ntDate
				? formatDateTime(new Date(arrPOGISFilt[ii].ntDate), i18n)
				: '',

			arrPOGISFilt[ii].nfDate
				? formatDateTime(new Date(arrPOGISFilt[ii].nfDate), i18n)
				: '',

			arrPOGISFilt[ii].modelYear
				? formatDateTime(new Date(arrPOGISFilt[ii].modelYear), i18n)
				: '',

			(arrPOGISFilt[ii].otherDates ?? [])
				.map(
					x =>
						(x.date ? formatDateTime(new Date(x.date), i18n) : '') +
						' (' +
						x.dateType +
						')',
				)
				.join(';\n'),
			arrPOGISFilt[ii].regulationStatus,
			arrPOGISFilt[ii].editor,
			(arrPOGISFilt[ii].associations ?? []).join(';\n'),
			(arrPOGISFilt[ii].relatedDocuments ?? []).join(';\n'),
			'',
			arrPOGISFilt[ii].docStatus,
		]);
		intRowCount++;

		const arrAttach = arrPOGISFilt[ii].pogisAttachments ?? [];
		arrAttach.forEach((iAttach, nn) => {
			row = sheet.getRow(intRowCount);
			row.outlineLevel = 1;
			row.getCell('B').fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: {argb: '8DB4E2'},
			};
			row.getCell('L').style.font = {
				underline: true,
				bold: false,
				color: {argb: '00B0F0'},
			};
			row.getCell('M').style.font = {
				underline: true,
				bold: false,
				color: {argb: '00B0F0'},
			};
			table.addRow([
				'',
				'',
				'',
				'',
				'',
				{
					text: iAttach.attachmentId,
					hyperlink: iAttach.file.uri,
					tooltip: t('Link', {
						ns: 'components/EntityList/ExcelExport',
						keyPrefix: 'TooltipsText',
					}),
				},
				'',
				'',
				'',
				'',
				'',
				'',
				'',
				'',
				'',
				'',
			]);
			intRowCount++;
		});
	}

	table.commit();
	const strZipName = strPageName;
	await createZIPXL(workbook, strZipName, t);
};
